import { createTheme } from '@mui/material/styles'

/**
 * Brand-inspired palette (teal + deep navy).
 * If you have an official brand guide, you can drop exact hex codes here.
 */
export const appTheme = createTheme({
  palette: {
    mode: 'light',
    // Fischer Identity primary
    primary: { main: '#124A87' },
    secondary: { main: '#0B1F2A' },
    background: { default: '#F6F8FB', paper: '#FFFFFF' }
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: [
      'Inter',
      'system-ui',
      '-apple-system',
      'Segoe UI',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif'
    ].join(',')
  },
  components: {
    MuiButton: {
      defaultProps: { variant: 'contained' }
    }
  }
})
